import PropTypes from 'prop-types';
import React from 'react';
import ShareIcon from './ShareIcon';
import BsFacebook from '../icons/BsFacebook';
import BsLinkedin from '../icons/BsLinkedin';
import BsPinterest from '../icons/BsPinterest';
import BsTwitter from '../icons/BsTwitter';
import { useLocation } from 'react-router-dom';
import '../styles/ShareIconList.css';


/** CONFIGURATION */
const BASE_URL = process.env.APP_URL.replace(/\/$/, '');

const ShareIconList = ({iconSize}) => {
    const location = useLocation();
    const url = `${BASE_URL}${location.pathname}`;

    return <div
        className={'share-icon-list'}>
        <ShareIcon
            link={`https://www.facebook.com/sharer.php?u=${url}`}><BsFacebook
                size={iconSize}
                color={'#425dab'} /></ShareIcon>
        <ShareIcon
            link={`https://twitter.com/share?url=${url}`}><BsTwitter
                size={iconSize}
                color={'#2fa1f3'} /></ShareIcon>
        <ShareIcon
            link={`https://linkedin.com/shareArticle?mini=true&url=${url}`}><BsLinkedin
                size={iconSize}
                color={'#2177b5'} /></ShareIcon>
        <ShareIcon
            link={`https://pinterest.com/pin/create/button/?url=${url}`}><BsPinterest
                size={iconSize}
                color={'#be362d'} /></ShareIcon>
    </div>;
};

ShareIconList.propTypes = {
    iconSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ShareIconList;